import { render, staticRenderFns } from "./success-message.vue?vue&type=template&id=5a01a85d&scoped=true"
import script from "./success-message.vue?vue&type=script&lang=js"
export * from "./success-message.vue?vue&type=script&lang=js"
import style0 from "./success-message.vue?vue&type=style&index=0&id=5a01a85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01a85d",
  null
  
)

export default component.exports